import { useBreakpointValue } from "@gluestack-style/react";
import { AlertStyleMap } from "./constants";
import { AlertModalVariant } from "./types";

export const useAlertModalController = ({
  variant
}: {
  variant?: AlertModalVariant;
}) => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false
  });

  const style = variant ? AlertStyleMap[variant] : null;

  return { isMobile, style };
};
